
import { HuntrixSong } from './types';

export const FREE: HuntrixSong = {
    id: 'FREE',
    title: "Free",
    artist: "HUNTR/X",
    midiFileName: "Free.mid",
    mp3FileName: "Free.mp3",
    sequencedTracks: [
        {
            "name": "Grand Piano",
            "notes": [
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "0:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "0:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "0:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "2n",
                    "time": "0:0:3",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "1:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "1:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "1:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "1:0:3",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "2:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "2:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "2:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "2:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "3:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "3:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "3:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "3:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "4:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "4:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "4:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "4:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "5:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "5:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "5:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "5:0:3",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "6:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "6:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "6:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "6:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "7:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "7:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "7:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "7:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "8:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "8:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "8:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "8:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F#2",
                    "duration": "1m",
                    "time": "8:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "10:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "10:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "10:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "10:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "10:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F2",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "48:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "48:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "F#4",
                    "duration": "1m",
                    "time": "48:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "48:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "49:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "49:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "49:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "49:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "50:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "50:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "50:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "50:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "51:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "51:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "51:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "51:2:2",
                    "velocity": 0.47
                }
            ]
        },
        {
            "name": "Violin",
            "notes": [
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "4:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "4:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "5:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "2n",
                    "time": "5:0:3",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "6:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "6:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "7:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "7:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "8:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "8:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "9:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "10:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "10:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "11:0:0",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "12:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "12:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "13:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "13:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "13:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "14:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "14:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "15:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "15:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "16:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "16:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "17:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "17:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "17:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "18:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "18:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "19:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "19:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "20:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "20:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "2n",
                    "time": "20:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "21:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#5",
                    "duration": "4n",
                    "time": "21:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "21:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "21:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "21:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "2n",
                    "time": "21:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "22:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "22:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "22:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "23:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "23:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "28:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "28:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "29:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "29:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "29:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "30:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "30:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "2n",
                    "time": "31:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "2n",
                    "time": "31:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "32:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "32:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "33:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "33:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "33:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "33:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "34:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "34:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "34:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "34:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "34:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "35:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "35:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "35:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "35:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "35:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "36:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "36:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "36:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "37:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "37:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "37:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "37:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "37:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "38:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "38:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "38:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "38:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "38:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "39:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "39:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "39:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "39:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "39:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "40:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "40:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "40:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "40:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "41:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "41:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "41:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "41:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "41:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "42:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "42:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "42:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "42:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "42:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "43:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "43:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "43:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "43:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "43:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "44:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "44:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "44:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "2n",
                    "time": "44:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "45:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "4n",
                    "time": "45:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "45:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "45:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "45:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "46:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "46:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "46:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "46:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "46:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "47:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "47:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "47:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "47:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "4n",
                    "time": "47:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "F#5",
                    "duration": "4n",
                    "time": "48:0:2",
                    "velocity": 0.02
                },
                {
                    "name": "F5",
                    "duration": "4n",
                    "time": "48:1:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#4",
                    "duration": "1m",
                    "time": "48:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "A#4",
                    "duration": "1m",
                    "time": "48:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "F4",
                    "duration": "1m",
                    "time": "49:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "49:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C5",
                    "duration": "1m",
                    "time": "50:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "D#4",
                    "duration": "1m",
                    "time": "50:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#5",
                    "duration": "1m",
                    "time": "50:3:2",
                    "velocity": 0.02
                },
                {
                    "name": "G#4",
                    "duration": "1m",
                    "time": "51:2:2",
                    "velocity": 0.02
                },
                {
                    "name": "C4",
                    "duration": "1m",
                    "time": "51:2:2",
                    "velocity": 0.02
                }
            ]
        },
        {
            "name": "Smooth Synth",
            "notes": [
                {
                    "name": "F#0",
                    "duration": "2n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "4n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "4n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "4n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#0",
                    "duration": "2n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "4n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "4n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#0",
                    "duration": "2n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "4n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "4n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#0",
                    "duration": "2n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "4n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#0",
                    "duration": "2n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "4n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "4n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#0",
                    "duration": "2n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "4n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "4n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "2n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C1",
                    "duration": "4n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "1m",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "42:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "4n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F0",
                    "duration": "4n",
                    "time": "44:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "2n",
                    "time": "44:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C1",
                    "duration": "4n",
                    "time": "45:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#1",
                    "duration": "1m",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#0",
                    "duration": "1m",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#0",
                    "duration": "2n",
                    "time": "48:0:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "EDM Kit (E)",
            "notes": [
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "42:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "42:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "43:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "44:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "44:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "44:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "A1",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#1",
                    "duration": "16n",
                    "time": "48:2:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "2023 Drum Kit",
            "notes": [
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "14:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "15:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "20:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "21:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "23:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "24:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "35:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "36:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "37:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "37:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "39:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#1",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "40:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "41:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "42:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "43:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "B2",
                    "duration": "2n",
                    "time": "44:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D3",
                    "duration": "2n",
                    "time": "44:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "44:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "45:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "46:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "47:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F#2",
                    "duration": "16n",
                    "time": "48:2:1",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Acoustic Guitar",
            "notes": [
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "12:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "12:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "12:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "13:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "13:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "13:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "13:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "13:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "13:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "13:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "14:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "14:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "14:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "14:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "14:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "15:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "15:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "15:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "15:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "15:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "15:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "15:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "15:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "16:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "16:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "16:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "16:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "16:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "16:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "16:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "16:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "17:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "17:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "17:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "17:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "17:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "17:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "17:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "17:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "18:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "18:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "18:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "18:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "18:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "18:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "19:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "19:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "19:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "19:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "19:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "19:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "19:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "19:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "19:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "20:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "20:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "20:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "20:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "20:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "20:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "20:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "20:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "21:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "21:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "21:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "21:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "21:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "21:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "21:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "21:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "22:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "22:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "22:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "22:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "22:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "22:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "23:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "23:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "23:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "23:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "23:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "23:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "23:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "23:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "24:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "24:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "24:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "24:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "24:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "28:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "28:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "28:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "29:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "29:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "29:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "29:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "29:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "29:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "29:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "29:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "30:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "30:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "30:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "30:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "30:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "30:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "30:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "30:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "31:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "31:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "31:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "31:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "31:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "31:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "31:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "31:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "32:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "32:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "32:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "32:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "32:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "32:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "32:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "32:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "33:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "33:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "33:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "33:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "33:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "33:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "33:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "34:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "34:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "34:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "34:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "34:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "34:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "35:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "35:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "35:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "35:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "35:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "35:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "35:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "35:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "36:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "36:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "36:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "36:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "36:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "36:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "36:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "36:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "37:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "37:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "37:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "37:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "37:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "37:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "37:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "37:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "38:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "38:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "38:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "38:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "38:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "38:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "39:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "39:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "39:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "39:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "39:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "39:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "39:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "39:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "39:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "40:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "40:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "40:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "40:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "40:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "40:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "40:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "40:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "40:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "41:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "41:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "41:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "41:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "41:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "41:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "41:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "41:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "41:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "41:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "42:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "42:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "42:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "42:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "42:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "42:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "42:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "42:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "42:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "43:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "43:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "43:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "43:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "43:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "43:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "43:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "43:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "43:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "44:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "44:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "44:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "44:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "44:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "44:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "44:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "44:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "44:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "44:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "45:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "45:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "45:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "45:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "45:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "45:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "45:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "45:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "45:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "45:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "46:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "46:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "46:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "46:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "46:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "46:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "46:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "46:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "46:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "47:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "47:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "47:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "47:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "47:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "47:2:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "47:2:3",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "47:3:1",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "47:3:2",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "48:0:0",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "48:0:1",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "48:0:3",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "48:1:0",
                    "velocity": 0.08
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "48:1:2",
                    "velocity": 0.08
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "48:2:0",
                    "velocity": 0.08
                }
            ]
        },
        {
            "name": "Music Box",
            "notes": [
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "0:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "4:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "12:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "13:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "16:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "17:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "20:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "21:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "21:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "22:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "24:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "25:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "16n",
                    "time": "48:2:2",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Bass",
            "notes": [
                {
                    "name": "D4",
                    "duration": "16n",
                    "time": "53:3:3",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Riser",
            "notes": [
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "24:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "32:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "40:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "44:2:0",
                    "velocity": 0.08
                },
                {
                    "name": "G2",
                    "duration": "2n",
                    "time": "48:2:0",
                    "velocity": 0.08
                }
            ]
        },
        {
            "name": "8-Bit Sine",
            "notes": [
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "24:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "25:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "25:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "25:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "26:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "26:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "26:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#2",
                    "duration": "2n",
                    "time": "27:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "2n",
                    "time": "27:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "2n",
                    "time": "27:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "40:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "41:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "41:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "41:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "42:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "1m",
                    "time": "42:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "42:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "43:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "43:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "43:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#2",
                    "duration": "1m",
                    "time": "44:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "44:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F#3",
                    "duration": "1m",
                    "time": "44:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "A#3",
                    "duration": "1m",
                    "time": "45:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "45:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C#3",
                    "duration": "1m",
                    "time": "45:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "46:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "D#3",
                    "duration": "1m",
                    "time": "46:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#3",
                    "duration": "1m",
                    "time": "46:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "F3",
                    "duration": "1m",
                    "time": "47:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "C3",
                    "duration": "1m",
                    "time": "47:2:2",
                    "velocity": 0.16
                },
                {
                    "name": "G#2",
                    "duration": "1m",
                    "time": "47:2:2",
                    "velocity": 0.16
                }
            ]
        },
        {
            "name": "Electric Piano (Both)",
            "notes": [
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "31:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:2:4",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "31:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "31:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:3:4",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "32:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "32:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "32:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "32:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "32:0:4",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "32:1:1",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "32:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "32:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "32:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "32:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "32:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "33:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "33:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "33:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "33:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "33:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "33:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "33:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "33:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "33:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "33:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "34:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "34:0:3",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "34:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "34:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "34:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "34:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "34:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "35:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "35:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "4n",
                    "time": "35:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "35:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "35:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "35:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "35:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "35:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "35:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "35:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "36:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "36:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "36:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "36:1:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "36:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "36:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "36:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "36:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "36:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "36:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "37:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "37:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "37:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "37:1:3",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "37:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "37:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "37:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "37:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "37:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "38:0:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "38:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "38:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "38:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "38:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "39:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "39:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "39:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "39:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "39:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "A#4",
                    "duration": "8n",
                    "time": "39:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "39:3:0",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "39:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "39:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "39:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "40:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "40:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "40:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "50:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "50:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "50:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "50:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "50:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "50:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "50:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "51:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "51:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "51:1:0",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "51:2:0",
                    "velocity": 0.39
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "51:2:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "51:2:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "51:2:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "51:3:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "51:3:2",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "51:3:3",
                    "velocity": 0.39
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "52:0:1",
                    "velocity": 0.39
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "52:0:2",
                    "velocity": 0.39
                },
                {
                    "name": "A#3",
                    "duration": "2n",
                    "time": "52:1:0",
                    "velocity": 0.39
                }
            ]
        },
        {
            "name": "Rumi",
            "notes": [
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "4:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "4:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "4:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "4:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "4:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "4:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "4:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "4:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "5:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "5:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "5:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "5:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "5:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "5:1:4",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "5:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "5:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "5:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "5:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "5:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "5:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "6:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "6:1:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "6:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "6:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "2n",
                    "time": "6:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "7:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "7:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "7:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "7:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "7:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "8:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "8:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "8:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "8:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "8:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "8:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "8:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "8:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "8:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "8:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "9:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "9:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "9:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "9:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "9:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "9:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "9:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "9:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "9:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "9:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "10:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "10:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "10:0:4",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "8n",
                    "time": "10:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "10:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "10:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "10:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "10:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "10:2:4",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "4n",
                    "time": "10:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "11:0:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "11:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "4n",
                    "time": "11:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "11:1:1",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "11:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "11:1:4",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "11:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "11:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "12:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "12:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "12:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "12:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "12:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "12:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "12:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:0:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "13:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "13:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "13:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "13:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "13:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "13:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "13:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "13:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "13:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:0:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "14:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "14:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "14:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "14:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "14:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "14:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "14:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "15:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "15:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "4n",
                    "time": "15:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "15:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "15:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "15:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "15:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "15:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "15:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "15:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "16:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "16:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "16:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "16:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "16:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "16:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "16:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "16:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "16:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "17:0:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "17:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "17:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "17:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "17:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "17:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "17:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "17:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "17:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "17:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "17:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "17:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:0:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "18:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "18:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "18:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "18:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "18:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "18:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "18:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "19:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "19:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "19:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "19:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "19:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "19:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "19:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "19:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "19:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "19:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "20:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "20:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "20:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "20:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "20:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "20:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "20:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "20:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "20:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "20:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "21:0:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "21:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "21:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "21:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "21:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "21:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "21:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "21:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "21:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "22:0:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "22:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "22:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "22:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "22:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "23:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "23:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "23:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "23:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "23:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "23:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "23:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "23:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "23:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "23:3:3",
                    "velocity": 0.79
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "24:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "24:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "24:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "32:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "32:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "33:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "33:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "40:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "40:1:3",
                    "velocity": 0.79
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "40:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "40:2:1",
                    "velocity": 0.79
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "40:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "40:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "41:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "41:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "41:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "41:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "42:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "42:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "42:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "44:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "45:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "45:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "4n",
                    "time": "45:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "A#4",
                    "duration": "4n",
                    "time": "45:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "4n",
                    "time": "46:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "46:1:2",
                    "velocity": 0.79
                },
                {
                    "name": "C#5",
                    "duration": "1m",
                    "time": "46:2:0",
                    "velocity": 0.79
                },
                {
                    "name": "C5",
                    "duration": "2n",
                    "time": "47:2:2",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "48:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "48:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "48:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "48:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "49:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "49:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "49:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "49:1:0",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "49:2:3",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "49:3:0",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "49:3:1",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "49:3:2",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "50:0:1",
                    "velocity": 0.79
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "50:0:2",
                    "velocity": 0.79
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "50:0:3",
                    "velocity": 0.79
                },
                {
                    "name": "A#3",
                    "duration": "8n",
                    "time": "50:1:0",
                    "velocity": 0.79
                }
            ]
        },
        {
            "name": "Jinu",
            "notes": [
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "24:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "8n",
                    "time": "24:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "24:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "24:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "25:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "25:0:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "25:0:4",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "25:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "25:1:2",
                    "velocity": 0.47
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "25:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "25:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "25:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "25:2:4",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "25:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "25:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#3",
                    "duration": "16n",
                    "time": "26:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "26:0:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "26:0:4",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "16n",
                    "time": "26:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "G#3",
                    "duration": "8n",
                    "time": "26:1:2",
                    "velocity": 0.47
                },
                {
                    "name": "F3",
                    "duration": "16n",
                    "time": "26:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "26:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "26:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "26:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "26:2:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "26:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "26:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "26:3:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "26:3:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:0:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "27:0:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:0:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "27:1:2",
                    "velocity": 0.47
                },
                {
                    "name": "C4",
                    "duration": "16n",
                    "time": "27:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "27:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:2:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "27:3:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "27:3:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:0:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "28:0:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:0:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "28:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "28:1:2",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "28:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "28:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "28:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:2:4",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:3:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "28:3:4",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:0:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:0:4",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:1:0",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "29:1:2",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "29:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "29:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "16n",
                    "time": "29:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:2:4",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:3:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "29:3:4",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:0:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "30:0:3",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:0:4",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "A#3",
                    "duration": "16n",
                    "time": "30:1:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "30:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "30:2:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "30:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "30:3:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "31:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:0:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "31:0:4",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:1:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:1:2",
                    "velocity": 0.47
                },
                {
                    "name": "C#4",
                    "duration": "16n",
                    "time": "31:1:4",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "16n",
                    "time": "31:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "32:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "32:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "33:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "33:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "42:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "42:3:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "42:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "42:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "43:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "43:1:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "43:1:3",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "43:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "43:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "43:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "43:3:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "43:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "8n",
                    "time": "44:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "46:2:3",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "46:3:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "46:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "46:3:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "47:0:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "47:0:1",
                    "velocity": 0.47
                },
                {
                    "name": "F4",
                    "duration": "8n",
                    "time": "47:1:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "47:1:3",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "16n",
                    "time": "47:2:0",
                    "velocity": 0.47
                },
                {
                    "name": "C#5",
                    "duration": "16n",
                    "time": "47:2:1",
                    "velocity": 0.47
                },
                {
                    "name": "C5",
                    "duration": "8n",
                    "time": "47:2:2",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "16n",
                    "time": "47:3:0",
                    "velocity": 0.47
                },
                {
                    "name": "G#4",
                    "duration": "8n",
                    "time": "47:3:1",
                    "velocity": 0.47
                },
                {
                    "name": "D#4",
                    "duration": "4n",
                    "time": "48:0:0",
                    "velocity": 0.47
                }
            ]
        }
    ],
    structure: [
        { type: 'INTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["(Free...)", "Yeah, yeah.", "Just let it go."] },
        { type: 'VERSE', duration: 32, rhythm: 'BUILDUP', lyrics: ["I tried to hide but something broke", "I tried to sing, couldn't hit the notes", "The words kept catching in my throat", "Suffocating, yeah, I couldn't float"] },
        { type: 'PRE_CHORUS', duration: 16, rhythm: 'BUILDUP', lyrics: ["But here with you, I can finally breathe", "You say you're no good, but you're good for me", "Ignite the spark, set the spirit free"] },
        { type: 'CHORUS', duration: 32, rhythm: 'BUILDUP', lyrics: ["Why does it feel right every time I let you in?", "Why does it feel like I can tell you anything?", "All the secrets that keep me in chains", "We're breaking out, we're breaking out today!"] },
        { type: 'VERSE', duration: 32, rhythm: 'BUILDUP', lyrics: ["You got a dark side, guess you're not the only one", "What if we both tried fighting what we're running from?", "We can't fix it if we never face it", "No looking back, we're gonna erase it"] },
        { type: 'CHORUS', duration: 32, rhythm: 'BUILDUP', lyrics: ["Why does it feel right every time I let you in?", "Why does it feel like I can tell you anything?", "We can't fix it if we never face it", "What if we find a way to escape it?"] },
        { type: 'BRIDGE', duration: 16, rhythm: 'MINIMAL', lyrics: ["We could be free...", "Yeah, we could be free...", "Let the past be the past 'til it's weightless", "Ready to fly?"] },
        { type: 'DROP', duration: 16, rhythm: 'ANTHEM', lyrics: ["(FREE!)", "Fly high!", "Don't look down!", "(FREE!)"] },
        { type: 'OUTRO', duration: 16, rhythm: 'MINIMAL', lyrics: ["We are free.", "Finally free."] }
    ],
    musicalData: {
        keyRoot: "Bb",
        scale: "major",
        bpm: 128,
        defaultTheme: {
            chordProgression: [0, 3, 4, 5],
            bassPattern: [1, 0, 1, 0, 1, 0, 1, 0],
            melodyPattern: [0, 2, 4, 5, 4, 2, 0, null]
        },
        themes: {
            INTRO: {
                chordProgression: [0, 5, 3, 4],
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0],
                // Pluck Pattern: Bb - D - F - G (add9 feel)
                melodyPattern: [0, 4, 7, 9, 7, 4, 0, 4, 7, 9, 12, 9, 7, 4, 0, null]
            },
            VERSE: {
                chordProgression: [0, 5], // I - vi
                bassPattern: [1, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0], // Deep House Bass
                melodyPattern: [2, 2, 2, 0, null, 0, null, null, 2, 2, 4, 0, null, 0, -2, 0]
            },
            PRE_CHORUS: {
                chordProgression: [3, 4, 5, 4], // IV - V - vi - V
                bassPattern: [1, 1, 1, 1, 1, 1, 1, 1], // Driving 8ths
                melodyPattern: [5, 5, 7, 7, 9, 9, 11, 12, 12, 12, 14, 14, 14, 14, 16, 16] // Rising
            },
            CHORUS: {
                chordProgression: [3, 0, 4, 5], // IV - I - V - vi
                bassPattern: [1, 0, 1, 1, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 1], // Syncopated
                // "Why does it feel right..."
                melodyPattern: [7, 7, 7, 5, 4, 4, 4, 0, 7, 9, 11, 12, 12, 0, 0, 0]
            },
            DROP: {
                chordProgression: [0, 3, 5, 4],
                bassPattern: [1, 0, 1, 0, 1, 0, 1, 0],
                // Vocal Chop / Lead Synth Solo
                melodyPattern: [12, 0, 12, 16, 14, 12, 9, 7, 12, 0, 12, 16, 14, 12, 19, 19]
            },
            BRIDGE: {
                chordProgression: [5, 0], // vi - I
                bassPattern: [1, 0, 0, 0, 0, 0, 0, 0], // Long sustain
                melodyPattern: [4, null, 2, null, 0, null, -3, null, 0, 2, 4, 7, 12, null, null, null]
            }
        }
    }
};
